import axios from "axios";
import { getApiBaseUrl } from "./apiBase";
import { setAuthTokens, clearAuthTokens } from "./authStorage";

let inFlight = null;

/**
 * Calls POST /refresh once; concurrent callers share the same in-flight request
 * so only one rotation happens per refresh JWT (matches server rotation semantics).
 */
export function rotateRefreshToken() {
  if (inFlight) {
    return inFlight;
  }
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    return Promise.reject(new Error("NO_REFRESH_TOKEN"));
  }

  inFlight = (async () => {
    try {
      const { data } = await axios.post(`${getApiBaseUrl()}/refresh`, {
        refreshToken,
      });
      const { accessToken, refreshToken: newRefresh } = data;
      setAuthTokens(accessToken, newRefresh);
      return { accessToken, refreshToken: newRefresh };
    } catch (err) {
      clearAuthTokens();
      throw err;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}
